import { render, staticRenderFns } from "./SmsAuthentication.vue?vue&type=template&id=07938c4e&"
import script from "./SmsAuthentication.vue?vue&type=script&lang=ts&"
export * from "./SmsAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports